import React from "react";

interface ApprovedSummaryContentProps {
  responseStatus?: string | null;
  authExpiryDate?: string | null;
}

/**
 * Displays the case summary layout for approved PA outcomes,
 * showing the response status and auth expiry date in a green card.
 */
const ApprovedSummaryContent: React.FC<ApprovedSummaryContentProps> = ({
  responseStatus,
  authExpiryDate,
}) => (
  <div className="flex flex-col rounded-[14px] border border-[#E6E6E6] shadow-sm">
    <div className="flex flex-col gap-4 bg-[rgba(247,249,250,0.5)] px-6 pb-6 pt-6">
      <div className="w-1/2">
        <div className="flex flex-col gap-2 rounded-[10px] border border-[#E6E6E6] bg-white p-4">
          <p className="text-[11px] font-bold uppercase tracking-[0.6px] text-[#5C5C5C]">
            Response Status
          </p>
          <p className="text-sm text-[#1F1F1F]">{responseStatus || "-"}</p>
        </div>
      </div>
      {authExpiryDate && (
        <div className="flex flex-col gap-2 rounded-[10px] bg-[#CAF6DF] p-4">
          <p className="text-[11px] font-bold uppercase tracking-[0.6px] text-[#008F32]">
            Auth Expiry Date
          </p>
          <p className="text-sm leading-[22px] text-[#3D3D3D]">
            {authExpiryDate}
          </p>
        </div>
      )}
    </div>
  </div>
);

export default ApprovedSummaryContent;
